import { gql } from '@apollo/client';

export default gql`
  query CourseById($courseId: String) {
    course(courseId: $courseId) @rest(path: "courses/{args.courseId}") {
      _id
      name
      professor {
        _id
        name
      }
      academy {
        _id
        name
        logoImageUrl
        features
      }
    }
  }
`;
